import {
    constructGiphy,
    constructInstagram,
    constructVimeo,
    constructYoutube,
    RenderSnippetAs,
} from 'mk2/apps/wiki/utils';
import { ASTAdditionalDataFromServer } from 'mk2/schemas';
import React from 'react';
import styles from './Snippet.mscss';

const YOUTUBE_SNIPPET_RE = /youtube#video=([\w-]+)/;
const VIMEO_SNIPPET_RE = /vimeo#video=([\w-]+)/;
const GIPHY_SNIPPET_RE = /giphy#gif=([\w-]+)/;
const INSTAGRAM_SNIPPET_RE = /instagram#post=([\w-]+)/;

interface OwnProps {
    snippet: string;
    astAdditionalData: ASTAdditionalDataFromServer;
}

export const Snippet = React.memo<OwnProps>(({
    snippet, astAdditionalData,
}) => {
    const youtubeMatcher = new RegExp(YOUTUBE_SNIPPET_RE, 'g');
    const vimeoMatcher = new RegExp(VIMEO_SNIPPET_RE, 'g');
    const giphyMatcher = new RegExp(GIPHY_SNIPPET_RE, 'g');
    const instagramMatcher = new RegExp(INSTAGRAM_SNIPPET_RE, 'g');

    const youtubeMatch = youtubeMatcher.exec(snippet);
    const vimeoMatch = vimeoMatcher.exec(snippet);
    const giphyMatch = giphyMatcher.exec(snippet);
    const instagramMatch = instagramMatcher.exec(snippet);

    let retVal = null;

    if (youtubeMatch && !retVal) {
        const code = youtubeMatch[1];
        retVal = (
            <div className={styles.Snippet}>
                {constructYoutube(
                    code,
                    620,
                    348,
                )}
            </div>
        );
    }
    if (vimeoMatch && !retVal) {
        const code = vimeoMatch[1];
        retVal = (
            <div className={styles.Snippet}>
                {constructVimeo(
                    code,
                    620,
                    348,
                )}
            </div>
        );
    }
    if (giphyMatch && !retVal) {
        const code = giphyMatch[1];
        retVal = (
            <div className={styles.Snippet}>
                {constructGiphy(
                    code,
                    620,
                    348,
                )}
            </div>
        );
    }
    if (instagramMatch && !retVal) {
        const code = instagramMatch[1];

        const instagramData = astAdditionalData && astAdditionalData.instagramData && astAdditionalData.instagramData[code]
            ? astAdditionalData.instagramData[code]
            : null;

        retVal = (
            <div className={styles.Snippet}>
                {constructInstagram(
                    code,
                    1040,
                    RenderSnippetAs.HTML_IFRAME,
                    instagramData,
                )}
            </div>
        );
    }

    return retVal;
});
